import { ReactNode } from "react";
import { cn } from "@/utils";

// Wraps the Icons for each CalendarEvent

export const IconWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) => {
  return (
    <div
      className={cn(
        "flex h-[10px] w-[10px] items-center justify-center rounded-full p-[1px] text-white",
        className,
      )}
    >
      {children}
    </div>
  );
};
